import React from 'react';
import { CustomSelect } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Select } from 'antd';
import PropTypes from 'prop-types';

export const PAYMENT_STATUS = {
  ALL: 'all',
  PAID: 'paid',
  UNPAID: 'unpaid',
};

function SelectPaymentStatus({ selectedStatus, onChange }) {
  return (
    <CustomSelect
      placeholder="Filtrar por status de pagamento"
      value={selectedStatus}
      onChange={onChange}
    >
      <Select.Option
        key="payment-status-all"
        value={PAYMENT_STATUS.ALL}
      >
        Todos
      </Select.Option>
      <Select.Option
        key="payment-status-paid"
        value={PAYMENT_STATUS.PAID}
      >
        Pago
      </Select.Option>
      <Select.Option
        key="payment-status-unpaid"
        value={PAYMENT_STATUS.UNPAID}
      >
        Pendente
      </Select.Option>
    </CustomSelect>
  );
}

SelectPaymentStatus.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedStatus: PropTypes.oneOf(Object.values(PAYMENT_STATUS)),
};

SelectPaymentStatus.defaultProps = {
  selectedStatus: PAYMENT_STATUS.ALL,
};

export default SelectPaymentStatus;
